export default "__VITE_ASSET__DLUtek9l__"